import "antd/lib/message/style";
import _message from "antd/lib/message";
import _asyncToGenerator from "/home/runner/work/gtintel/gtintel/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/home/runner/work/gtintel/gtintel/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/home/runner/work/gtintel/gtintel/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "/home/runner/work/gtintel/gtintel/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _asyncIterator(r) { var n, t, o, e = 2; for ("undefined" != typeof Symbol && (t = Symbol.asyncIterator, o = Symbol.iterator); e--;) { if (t && null != (n = r[t])) return n.call(r); if (o && null != (n = r[o])) return new AsyncFromSyncIterator(n.call(r)); t = "@@asyncIterator", o = "@@iterator"; } throw new TypeError("Object is not async iterable"); }
function AsyncFromSyncIterator(r) { function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object.")); var n = r.done; return Promise.resolve(r.value).then(function (r) { return { value: r, done: n }; }); } return AsyncFromSyncIterator = function AsyncFromSyncIterator(r) { this.s = r, this.n = r.next; }, AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, "return": function _return(r) { var n = this.s["return"]; return void 0 === n ? Promise.resolve({ value: r, done: !0 }) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments)); }, "throw": function _throw(r) { var n = this.s["return"]; return void 0 === n ? Promise.reject(r) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments)); } }, new AsyncFromSyncIterator(r); }
import { useCallback, useEffect, useState } from 'react';
import moment from 'moment';
import { deleteAllNotifications } from '@gtintel/platform-api';
import { ADMIN_AVATAR, TWILIO_ADMIN_IDENTITY } from '@gtintel/platform-constants';
import firebase from '@gtintel/platform-firebase';
function useNotifications(user, app) {
  var _useState = useState(10),
    numberOfRenderedNotifications = _useState[0],
    setNumberOfRenderedNotifications = _useState[1];
  var _useState2 = useState([]),
    notifications = _useState2[0],
    setNotifications = _useState2[1];
  var _useState3 = useState([]),
    notificationsPaginated = _useState3[0],
    setNotificationsPaginated = _useState3[1];
  var _useState4 = useState(false),
    loaded = _useState4[0],
    setLoaded = _useState4[1];
  var _useState5 = useState(true),
    loadingPagination = _useState5[0],
    setLoadingPagination = _useState5[1];
  useEffect(function () {
    if (!(user !== null && user !== void 0 && user.id)) {
      return;
    }
    var databaseRef = firebase.database(firebase.apps[app]).ref(user !== null && user !== void 0 && user.is_administrator ? String(TWILIO_ADMIN_IDENTITY) : String(user === null || user === void 0 ? void 0 : user.id));
    databaseRef.orderByChild(app === 0 ? 'created_at' : 'update_date').limitToLast(100).on('value', function (snapshot) {
      var data = snapshot.val();
      if (data) {
        var firebaseNotifications = Object.entries(data).map(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];
          return _objectSpread(_objectSpread({}, value), {}, {
            notification_id: key,
            color: value.read ? value.color : 'aliceblue'
          });
        });
        Promise.all(firebaseNotifications.filter(function (notification) {
          return !notification.noti_badge || !notification.read;
        }).map(/*#__PURE__*/function () {
          var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(n) {
            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    return _context.abrupt("return", databaseRef.child(n.notification_id).update({
                      noti_badge: true,
                      read: true
                    }));
                  case 1:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));
          return function (_x) {
            return _ref3.apply(this, arguments);
          };
        }()));
        setNotifications(firebaseNotifications.sort(function (firstNotification, secondNotification) {
          var _firstNotification$cr, _secondNotification$c;
          return moment((_firstNotification$cr = firstNotification.created_at) !== null && _firstNotification$cr !== void 0 ? _firstNotification$cr : firstNotification.update_date).isAfter((_secondNotification$c = secondNotification.created_at) !== null && _secondNotification$c !== void 0 ? _secondNotification$c : secondNotification.update_date) ? -1 : 1;
        }));
      }
      setLoaded(true);
    });
    return function () {
      databaseRef.off();
    };
  }, [user, app]);
  var handleScroll = useCallback(function () {
    var bottom = Math.ceil(window.innerHeight + window.scrollY) >= document.documentElement.scrollHeight;
    if (bottom) {
      setNumberOfRenderedNotifications(numberOfRenderedNotifications + 10);
    }
  }, [numberOfRenderedNotifications]);
  useEffect(function () {
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return function () {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll]);
  useEffect(function () {
    function getNotificationsPaginated() {
      return _getNotificationsPaginated.apply(this, arguments);
    }
    function _getNotificationsPaginated() {
      _getNotificationsPaginated = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var newNotifications, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, item;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                setLoadingPagination(true);
                newNotifications = [];
                _iteratorAbruptCompletion = false;
                _didIteratorError = false;
                _context2.prev = 4;
                _iterator = _asyncIterator(notifications.slice(0, numberOfRenderedNotifications));
              case 6:
                _context2.next = 8;
                return _iterator.next();
              case 8:
                if (!(_iteratorAbruptCompletion = !(_step = _context2.sent).done)) {
                  _context2.next = 20;
                  break;
                }
                item = _step.value;
                if (item.sender_id) {
                  _context2.next = 13;
                  break;
                }
                newNotifications.push(_objectSpread(_objectSpread({}, item), {}, {
                  senderAvatar: undefined
                }));
                return _context2.abrupt("continue", 17);
              case 13:
                if (!(item.sender_id === TWILIO_ADMIN_IDENTITY)) {
                  _context2.next = 16;
                  break;
                }
                newNotifications.push(_objectSpread(_objectSpread({}, item), {}, {
                  senderAvatar: ADMIN_AVATAR
                }));
                return _context2.abrupt("continue", 17);
              case 16:
                newNotifications.push(_objectSpread(_objectSpread({}, item), {}, {
                  senderAvatar: undefined,
                  read: false
                }));
              case 17:
                _iteratorAbruptCompletion = false;
                _context2.next = 6;
                break;
              case 20:
                _context2.next = 26;
                break;
              case 22:
                _context2.prev = 22;
                _context2.t0 = _context2["catch"](4);
                _didIteratorError = true;
                _iteratorError = _context2.t0;
              case 26:
                _context2.prev = 26;
                _context2.prev = 27;
                if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) {
                  _context2.next = 31;
                  break;
                }
                _context2.next = 31;
                return _iterator["return"]();
              case 31:
                _context2.prev = 31;
                if (!_didIteratorError) {
                  _context2.next = 34;
                  break;
                }
                throw _iteratorError;
              case 34:
                return _context2.finish(31);
              case 35:
                return _context2.finish(26);
              case 36:
                setLoadingPagination(false);
                setNotificationsPaginated(newNotifications);
              case 38:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[4, 22, 26, 36], [27,, 31, 35]]);
      }));
      return _getNotificationsPaginated.apply(this, arguments);
    }
    getNotificationsPaginated();
  }, [notifications, numberOfRenderedNotifications]);
  function removeNotification(_x2) {
    return _removeNotification.apply(this, arguments);
  }
  function _removeNotification() {
    _removeNotification = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(notificationId) {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return firebase.database(firebase.apps[app]).ref(String(user === null || user === void 0 ? void 0 : user.id)).child(notificationId).remove();
            case 2:
              _message.success('Notification removed!');
            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
    return _removeNotification.apply(this, arguments);
  }
  function updateStatus(_x3) {
    return _updateStatus.apply(this, arguments);
  }
  function _updateStatus() {
    _updateStatus = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(notificationId) {
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return firebase.database(firebase.apps[app]).ref(String(user.id)).child(notificationId).update({
                status: true,
                read: true
              });
            case 2:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));
    return _updateStatus.apply(this, arguments);
  }
  return {
    notifications: notifications,
    loaded: loaded,
    removeNotification: removeNotification,
    deleteAllNotifications: deleteAllNotifications,
    updateStatus: updateStatus,
    notificationsPaginated: notificationsPaginated,
    loadingPagination: loadingPagination
  };
}
export default useNotifications;